import React from 'react'
import Common from '../../utils/common';
import { Redirect, Route, Switch } from "react-router";

export default class Detail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            category: null,
            relations: [],
            build: '',
            activePage: 15
        }
        var param = {};
        param['paramId'] = this.props.match.params.id;
        param['friendlyUrl'] = this.props.match.params.friendlyUrl;
        if (this.props.match.params.name != undefined) {
            window.location.href = "/" + this.props.match.params.language + "/bai-viet/" + this.props.match.params.name;

        }
        this.state.build = Common.getPage('article', param);
    }
    render() {

        return (

            <main>
                <div dangerouslySetInnerHTML={{ __html: this.state.build }}></div>
            </main>

        )

    }

}

